import './styles/Notifications.scss';

import {
  ArticleNotification as IArticleNotification,
  Notification as INotification
} from 'types/AppTypes';

import ArticleNotification from './components/ArticleNotification';
import JobOfferingNotification from './components/JobOfferingNotification';
import SelectionNotification from './components/SelectionNotification';

interface Props {
  notification: INotification;
  isLast?: boolean;
}

export default function Notification(props: Props) {
  switch (props.notification.type) {
    case 'article':
      return <ArticleNotification notification={props.notification as IArticleNotification} />;
    case 'selection':
      return <SelectionNotification notification={props.notification} />;
    case 'jobOfferingActive':
      return <JobOfferingNotification notification={props.notification} />;
    case 'jobOfferingEdited':
      return <JobOfferingNotification notification={props.notification} />;
    case 'jobOfferingExpired':
      return <JobOfferingNotification notification={props.notification} />;
    default: {
      return null;
    }
  }
}
